import React, { useEffect } from 'react';
import { EyeOutlined, MailOutlined } from '@ant-design/icons';
import { Button, notification } from 'antd';
import { onMessage } from 'firebase/messaging';
import { useHistory } from 'react-router';
import { useMarkNotificationSeen } from 'services/NotificationService';
import { messaging } from '../util/firebase';
import { PushNotification } from 'interfaces/notification';

export const useFirebaseNotifications = () => {
  const { mutate: markAsSeen } = useMarkNotificationSeen();
  const history = useHistory();

  useEffect(() => {
    console.log('🔔 Initializing Firebase notifications listener...');
    
    const unsubscribe = onMessage(
      messaging,
      (payload) => {
        console.log('📨 Foreground message received:', payload);
        const { messageId, notification: n } = payload;
        const notificationData: PushNotification = n as PushNotification;

        const markNotificationAsSeen = () => {
          markAsSeen(messageId);
          notification.open({
            message: notificationData.title,
            description: notificationData.body,
            icon: <MailOutlined />,
            showProgress: true,
            pauseOnHover: true,
            duration: 5,
            key: messageId,
            actions: (
              <>
                <Button
                  size="small"
                  type="text"
                  onClick={() => history.push('/inbox')}
                >
                  Ir al Inbox
                </Button>
                <Button
                  style={{ marginLeft: '8px' }}
                  size="small"
                  disabled
                  icon={<EyeOutlined />}
                />
              </>
            ),
          });
        };

        notification.open({
          message: notificationData.title,
          description: notificationData.body,
          icon: <MailOutlined />,
          showProgress: true,
          pauseOnHover: true,
          duration: 5,
          key: messageId,
          actions: (
            <>
              <Button
                size="small"
                type="text"
                onClick={() => history.push('/inbox')}
              >
                Ir al Inbox
              </Button>
              <Button
                style={{ marginLeft: '8px' }}
                size="small"
                type="primary"
                icon={<EyeOutlined />}
                onClick={() => markNotificationAsSeen()}
              >
                Marcar como leído
              </Button>
            </>
          ),
        });
      },
    );

    // Cleanup function
    return () => {
      unsubscribe();
    };
  }, [markAsSeen, history]);
};
